














































































































import {Component, PropSync, Watch} from "vue-property-decorator";
import { Action, Getter } from "vuex-class";
import { SelectWings, ToggleWings, InputWings } from "wings-ui-components";
import {notifyError} from "@/utils/notify-helper";
import BaseFilter from "@/components/Filter/BaseFilter";
import { PartnerUserFilter } from "@/store/user_management/partner_users/types";
import {getTranslatedParams} from "@/utils/notify-utils";

@Component({
  components: {
    SelectWings,
    ToggleWings,
    InputWings
  },
})
export default class PartnerUsersFilter extends BaseFilter<PartnerUserFilter> {
  @PropSync('filterProp') filterParent!: any;
  @PropSync('runFilter') run!: any;
  @PropSync("show") is_show!: boolean;

  @Getter("partnerUsers") partnerUsersList: any;
  @Getter("partnerUserRoles") partnerUserRolesList: any;

  @Action("getPartners") actionGetPartners: any;
  @Action("getPartnerUsers") actionGetPartnerUsers: any;
  @Action("getPartnerUserRoles") actionGetPartnerUserRoles: any;
  @Action("exportPartnerUsers") actionExportPartnerUsers: any;

  private statusesList = [1, 0];
  partnersList: any = []

  async getPartnersList(filter: any) {
    const items = await this.actionGetPartners(filter);
    this.partnersList = (filter?.page_number > 1) ? this.partnersList.concat(items) : items
  }

  get partnerUserRoles(){
    return [{ id: 0, name: '--Без роли--' }].concat(this.partnerUserRolesList);
  }

  async created() {
    this.actionGetPartnerUserRoles();
    this.filtered();
    this.scroll();
    if (this.filter.partner) this.partnersList = await this.actionGetPartners({name: this.filter.partner});
  }

  defaultFilter(): PartnerUserFilter {
    return {
      id: undefined,
      email: undefined,
      name: undefined,
      partner: undefined,
      status: undefined,
      role_id: undefined,
      page_number: 1
    };
  }

  async onFilteredAction(nextPage = false) {
    if (!nextPage) this.filter.page_number = 1;
    try {
      this.logObject = {
        action_page: this.$route.meta.msgKey,
        action: "Viewing",
        action_status: "success",
        object_type: "Personal account",
        addititional_info: getTranslatedParams(this.filter)
      }
      const resp = await this.actionGetPartnerUsers({...this.filter, is_ad_user: 0})
      await this.actionLog(this.logObject);
      this.is_last = resp.length == 0;
    } catch (err) {
      await this.actionLog({...this.logObject, action_status: "failed"});
      notifyError(err);
    } finally {
      this.moreLoading = false;
    }
  }

  async export() {
    this.logObject = {
      action_page: this.$route.meta.msgKey,
      action: "Export",
      action_status: "success",
      object_type: "Personal account",
      addititional_info: getTranslatedParams(this.filter)
    }
    try {
      await this.actionExportPartnerUsers(this.filter)
      await this.actionLog(this.logObject)
    } catch(error) {
      this.actionLog({...this.logObject, action_status: "failed"});
      notifyError(error);
    }
  }

  getPartnerRolesNameById(id: number): string | undefined {
    if (id === 0) return '--Без роли--';
    return this.partnerUserRolesList.find((e: any) => e.id === id)?.name;
  }

  @Watch('filter', {immediate: true, deep: true})
  onFilterChanged(val: PartnerUserFilter) {
    this.filterParent = val;
  }

  @Watch('run')
  onRunFilter(val: boolean) {
    if (!val) return;
    this.filtered();
    this.run = false;
  }
}
